import React, { useEffect, useRef, useState } from 'react';
import styles from './OffersManager.module.css';
import OfferCard from './OfferCard/OfferCard';
import { getOffers, putOffers } from '../../api/Trader/offers';
import { useNavigate } from 'react-router-dom';

const initialOffers = [
  { id: 1, title: '', description: '', active: false, icon: '/OffersManager/firstIcon.png' },
  { id: 2, title: '', description: '', active: false, icon: '/OffersManager/secondIcon.png' },
  { id: 3, title: '', description: '', active: false, icon: '/OffersManager/thirdIcon.png' },
];

const OffersManager = () => {
  const [offers, setOffers] = useState(initialOffers);
  const [error, setError] = useState('');
  const paraRef = useRef(null);
  const navigate = useNavigate();

  function updateOffer(index, patch) {
    setOffers(prev => prev.map((o, i) => (i === index ? { ...o, ...patch } : o)));
  }

  useEffect(() => {
    async function fetchOffers() {
        const result = await getOffers(navigate);
        if (!result.success) {
            if (paraRef.current) paraRef.current.style.color = 'red';
            setError('Erreur lors du chargement des offres');
        }

        const data = result.data;
        if (Array.isArray(data)) {
            setOffers(prev =>
            prev.map(o => {
                const fromApi = data.find(x => x.index === o.id);
                return {
                    ...o,
                    title: fromApi?.title ?? o.title,
                    description: fromApi?.description ?? o.description,
                    active: fromApi ? Boolean(fromApi.activated) : o.active,
                };
            })
            );
        }
    }
    fetchOffers();
  }, [navigate]); 

  // Envoi au backend
  async function handleForm(e) {
    e.preventDefault();
    try {
      await putOffers(offers);
      setError('Offres mises à jour avec succès');
      if (paraRef.current) paraRef.current.style.color = 'green';
    } catch {
      setError('Erreur lors de la mise à jour des offres');
      if (paraRef.current) paraRef.current.style.color = 'red';
    }
  }

  return (
    <form onSubmit={handleForm} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <div className={styles.layout}>
        {offers.map((offer, index) => (
          <OfferCard
            key={offer.id}
            id={offer.id}
            offer={offer}
            onChange={(patch) => updateOffer(index, patch)}
          />
        ))}
      </div>
      <p ref={paraRef} className={styles.error}>{error}</p>
      <button type="submit" className={styles.btn}>Mettre à jour</button>
    </form>
  );
};

export default OffersManager;
